<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'BUYERS.ACCESS_CONTROL_DIALOG_TITLE' | translate }}
    </h3>
    <div
      *ngIf="buyer?.blocked_reason"
      class="sp-padding sp-text__italic">
      <strong>{{ 'BUYERS.LOCK_REASON_LABEL' | translate }}:</strong>
      {{ buyer?.blocked_reason || '' }}
    </div>
    <div class="sp-padding">
      {{ 'BUYERS.ACCESS_CONTROL_DIALOG_MESSAGE' | translate : { email: buyer?.email } }}
    </div>

    <app-shared-button
      class="sp-width__full"
      [button_class]="'sp-button__main'"
      [spinner_class]="'sp-spinner__main'"
      [icon]="'lock_open'"
      [cta]="'GENERAL.UNBLOCK_USER_CTA'"
      [is_disabled]="isBlocked() || is_buyer_edit_running"
      [is_spinner_visible]="is_buyer_edit_running"
      (click)="unblock(this.buyer!)"></app-shared-button>
  </div>
</div>
